export default "__VITE_ASSET__CNXCWmZW__"